import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './recirc.css';

const Recirc = ({ subtitle, title, link }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <Link className={styles.link} to={link}>
          <h5 className={styles.subtitle}>{subtitle}</h5>
          <h4 className={styles.title}>{title}</h4>
        </Link>
      </div>
    </div>
  );
};

Recirc.propTypes = {
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default Recirc;
